import React from 'react';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { COMPANY } from '../../config/company';

const Logo = () => (
  <img src="/prasilabs-logo.png" alt="PRASI LABS" style={{ height: 32, width: 'auto', display: 'block' }} />
);

// roles: which roles can see this page. Omit to allow all roles.

const navItems = [
  { to: '/admin/dashboard', label: 'Dashboard', exact: true, color: '#2563eb', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/>
      <rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>
    </svg>
  )},
  { to: '/admin/clients', label: 'Clients', roles: ['admin','manager','bd','sales','procurement'], color: '#4f46e5', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/>
    </svg>
  )},
  { to: '/admin/partners', label: 'Partners', roles: ['admin','manager','bd','sales','procurement'], color: '#7c3aed', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
    </svg>
  )},
  { to: '/admin/customers', label: 'Customers', roles: ['admin','manager','bd','mr','sales','finance'], color: '#0891b2', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
    </svg>
  )},
  { to: '/admin/license-expiry', label: 'License Expiry', roles: ['admin','manager','mr','bd','sales'], color: '#d97706', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
      <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
    </svg>
  )},
  { to: '/admin/catalog', label: 'Catalog', color: '#0e7490', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/>
    </svg>
  )},
  { to: '/admin/chem-structure', label: 'Chem Structure', roles: ['admin','manager','bd','scientist','rnd_head','principal_scientist'], color: '#0f766e', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="4" r="2" fill="currentColor" stroke="none"/>
      <circle cx="4" cy="19" r="2" fill="currentColor" stroke="none"/>
      <circle cx="20" cy="19" r="2" fill="currentColor" stroke="none"/>
      <line x1="12" y1="6" x2="5" y2="17"/><line x1="12" y1="6" x2="19" y2="17"/><line x1="6" y1="19" x2="18" y2="19"/>
    </svg>
  )},
  { to: '/admin/inquiries', label: 'Inquiries', roles: ['admin','manager','bd','mr','sales','rnd_head','scientist','principal_scientist'], color: '#1d4ed8', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
    </svg>
  )},
  { to: '/admin/projects', label: 'Projects', roles: ['admin','manager','bd','scientist','rnd_head','principal_scientist'], color: '#059669', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/>
      <path d="M7 8h.01M11 8h6M7 12h.01M11 12h6"/>
    </svg>
  )},
  { to: '/admin/orders', label: 'Orders', roles: ['admin','manager','bd','mr','sales','finance','procurement'], color: '#ea580c', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/>
      <path d="M16 10a4 4 0 01-8 0"/>
    </svg>
  )},
  { to: '/admin/invoices', label: 'Invoices', roles: ['admin','manager','bd','finance','sales'], color: '#65a30d', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/>
      <line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
    </svg>
  )},
  { to: '/admin/proforma-invoices', label: 'Proforma Invoices', roles: ['admin','manager','bd','finance','sales'], color: '#16a34a', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/>
      <line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
      <circle cx="10" cy="9" r="1" fill="currentColor"/>
    </svg>
  )},
  { to: '/admin/purchase-orders', label: 'Purchase Orders', roles: ['admin','manager','bd','finance','procurement'], color: '#b45309', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/>
    </svg>
  )},
  { to: '/admin/proforma-invoice-orders', label: 'Proforma Invoice Orders', roles: ['admin','manager','bd','finance','sales'], color: '#c2410c', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/>
      <line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
      <path d="M9 9h1v1H9z" fill="currentColor" stroke="none"/>
    </svg>
  )},
  { to: '/admin/tax-invoice-orders', label: 'Tax Invoice Orders', roles: ['admin','manager','bd','finance','sales'], color: '#1d4ed8', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/>
      <line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
      <line x1="12" y1="9" x2="12" y2="9"/>
      <circle cx="12" cy="9" r="1.2" fill="currentColor" stroke="none"/>
    </svg>
  )},
  { to: '/admin/quotes', label: 'Quotes', roles: ['admin','manager','bd','mr','sales'], color: '#0284c7', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
      <line x1="9" y1="10" x2="15" y2="10"/><line x1="9" y1="14" x2="13" y2="14"/>
    </svg>
  )},
  { to: '/admin/capa', label: 'CAPA', roles: ['admin','manager','rnd_head','principal_scientist','scientist'], color: '#b91c1c', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
      <polyline points="9 12 11 14 15 10"/>
    </svg>
  )},
  { to: '/admin/coa', label: 'COA', roles: ['admin','manager','bd','scientist','rnd_head','principal_scientist'], color: '#15803d', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/>
      <rect x="9" y="3" width="6" height="4" rx="1"/>
      <path d="M9 12l2 2 4-4"/>
    </svg>
  )},
  { to: '/admin/activities', label: 'Activities', roles: ['admin','manager','mr','bd','sales'], color: '#e11d48', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
      <line x1="8" y1="14" x2="8" y2="14" strokeLinecap="round" strokeWidth="3"/><line x1="12" y1="14" x2="16" y2="14"/><line x1="8" y1="18" x2="8" y2="18" strokeLinecap="round" strokeWidth="3"/><line x1="12" y1="18" x2="14" y2="18"/>
    </svg>
  )},
  { to: '/admin/tasks', label: 'Tasks', color: '#7c3aed', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/>
    </svg>
  )},
  { to: '/admin/visits', label: 'Visits', roles: ['admin','manager','bd','mr','sales'], color: '#db2777', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/>
      <polyline points="16 11 18 13 22 9"/>
    </svg>
  )},
  { to: '/admin/tva', label: 'TVA', roles: ['admin','manager','mr','bd','sales'], color: '#a21caf', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
      <path d="M9 9l3-3 3 3M9 15l3 3 3-3"/>
    </svg>
  )},
  { to: '/admin/analytics', label: 'Analytics', roles: ['admin','manager','rnd_head','finance'], color: '#1e40af', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
    </svg>
  )},
  { to: '/admin/service-requests', label: 'Service Requests', color: '#dc2626', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/>
    </svg>
  )},
  { to: '/admin/attendance', label: 'Attendance', color: '#0f766e', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
      <polyline points="9 16 11 18 15 14"/>
    </svg>
  )},
  { to: '/admin/my-profile', label: 'My Employment', roles: null, color: '#475569', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <rect x="2" y="7" width="20" height="14" rx="2"/>
      <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/>
      <line x1="12" y1="12" x2="12" y2="16"/><line x1="10" y1="14" x2="14" y2="14"/>
    </svg>
  )},
  { to: '/admin/hr', label: 'HR', roles: ['admin', 'manager'], department: 'hr', color: '#9333ea', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/>
    </svg>
  )},
  { to: '/admin/accounting', label: 'Accounting', roles: ['admin','manager','finance','procurement'], color: '#15803d', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/>
      <line x1="7" y1="15" x2="10" y2="15"/><line x1="14" y1="15" x2="17" y2="15"/>
    </svg>
  )},
  { to: '/admin/receivables', label: 'Receivables', roles: ['admin','manager','finance'], color: '#b45309', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/>
    </svg>
  )},
  { to: '/admin/balance-sheet', label: 'Balance Sheet', roles: ['admin','manager','finance'], color: '#1d4ed8', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <rect x="2" y="3" width="20" height="18" rx="2"/><line x1="2" y1="9" x2="22" y2="9"/>
      <line x1="12" y1="9" x2="12" y2="21"/><line x1="7" y1="14" x2="10" y2="14"/><line x1="14" y1="14" x2="17" y2="14"/>
    </svg>
  )},
  { to: '/admin/gst-report', label: 'GST Report', roles: ['admin','manager','finance'], color: '#c2410c', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/>
      <line x1="9" y1="13" x2="15" y2="13"/><line x1="9" y1="17" x2="12" y2="17"/>
      <text x="8" y="12" style={{fontSize:'6px', fontWeight:'bold'}} fill="currentColor">GST</text>
    </svg>
  )},
  { to: '/admin/samples', label: 'Sample Mgmt', roles: ['admin','manager','mr','bd','sales'], color: '#0369a1', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <path d="M9 3H5a2 2 0 00-2 2v4m6-6h10a2 2 0 012 2v4M9 3v18m0 0h10a2 2 0 002-2V9M9 21H5a2 2 0 01-2-2V9m0 0h18"/>
    </svg>
  )},
  { to: '/admin/competitors', label: 'Competitors', roles: ['admin','manager','mr','bd','sales'], color: '#b91c1c', icon: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <circle cx="9" cy="7" r="4"/><path d="M3 21v-2a4 4 0 014-4h4a4 4 0 014 4v2"/>
      <line x1="16" y1="3" x2="22" y2="9"/><line x1="22" y1="3" x2="16" y2="9"/>
    </svg>
  )},
];

const adminItems = [
  {
    to: '/admin/users', label: 'User Management', roles: ['admin', 'manager', 'software'], color: '#4338ca', icon: (
      <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="8" r="4" /><path d="M4 20v-2a6 6 0 0112 0v2" />
        <path d="M16 11a4 4 0 010 8M20 20v-1a4 4 0 00-3-3.87" />
      </svg>
    )
  },
  {
    to: '/admin/web-inquiries', label: 'Web Inquiries', roles: ['admin', 'manager'], color: '#0369a1', icon: (
      <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        <path d="M9 12l2 2 4-4" />
      </svg>
    )
  },
  {
    to: '/admin/audit-logs', label: 'Audit Logs', roles: ['admin', 'manager', 'software'], color: '#64748b', icon: (
      <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
        <path d="M9 11l3 3L22 4" /><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" />
      </svg>
    )
  },
  {
    to: '/admin/company-settings', label: 'Company Settings', roles: ['admin'], color: '#374151', icon: (
      <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z" />
      </svg>
    )
  },
  {
    to: '/admin/territories', label: 'Territories', roles: ['admin', 'manager'], color: '#0f766e', icon: (
      <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
        <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21" />
        <line x1="9" y1="3" x2="9" y2="18" /><line x1="15" y1="6" x2="15" y2="21" />
      </svg>
    )
  },
  {
    to: '/admin/data-export', label: 'Data Export', roles: ['admin', 'manager', 'rnd_head', 'finance', 'software'], color: '#16a34a', icon: (
      <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
        <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" />
      </svg>
    )
  },
  {
    to: '/admin/email-templates', label: 'Email Templates', roles: ['admin', 'manager'], color: '#0369a1', icon: (
      <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></svg>
    )
  },
  {
    to: '/admin/webhooks', label: 'Webhooks', roles: ['admin'], color: '#7c3aed', icon: (
      <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
        <path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71" />
        <path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71" />
      </svg>
    )
  },
];

// Roles that are always treated as fully privileged (see everything unless dept-gated)
const SUPER_ROLES = ['admin', 'director', 'ceo'];

// Dashboard/profile always visible. For other pages:
// If user has custom allowed_pages, use that list. Otherwise fall back to role defaults.
const canSee = (item, user) => {
  const role = user?.role;
  if (SUPER_ROLES.includes(role)) return true;
  const key = item.to.replace('/admin/', '');
  // Department-gated items: visible if user's department matches OR role matches
  if (item.department) {
    const userDept = (user?.department || '').toLowerCase().replace(/[\s_-]/g, '');
    const itemDept = item.department.toLowerCase().replace(/[\s_-]/g, '');
    if (userDept === itemDept || userDept.includes(itemDept) || itemDept.includes(userDept)) return true;
    if (item.roles && item.roles.includes(role)) return true;
    return false;
  }
  if (!item.roles) return true; // no restriction = all roles
  const pages = user?.allowed_pages;
  if (pages && Array.isArray(pages)) return pages.includes(key);
  return item.roles.includes(role);
};

const NavItem = ({ item, onClose }) => (
  <NavLink to={item.to} end={item.exact} onClick={onClose}
    style={({ isActive }) => ({
      display: 'flex', alignItems: 'center', gap: 10, padding: '9px 12px',
      borderRadius: 8, marginBottom: 2, textDecoration: 'none', transition: 'all 0.15s',
      fontWeight: isActive ? 600 : 500, fontSize: '0.875rem',
      color: isActive ? (item.color || 'var(--primary)') : 'var(--text-secondary)',
      background: isActive ? (item.color || 'var(--primary)') + '18' : 'transparent',
    })}
    onMouseEnter={e => { if (e.currentTarget.getAttribute('aria-current') !== 'page') { e.currentTarget.style.background = (item.color || '#2563eb') + '10'; e.currentTarget.style.color = item.color || 'var(--text-secondary)'; } }}
    onMouseLeave={e => { if (e.currentTarget.getAttribute('aria-current') !== 'page') { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'var(--text-secondary)'; } }}
  >
    <span style={{ color: item.color || 'var(--primary)', display: 'flex', alignItems: 'center', flexShrink: 0 }}>
      {item.icon}
    </span>
    {item.label}
  </NavLink>
);

export default function Sidebar({ open, onClose }) {
  const { user, isAdmin, isManager } = useAuth();
  const navigate = useNavigate();
  const role = user?.role;

  const visibleNav = navItems.filter(i => canSee(i, user));
  const visibleAdmin = adminItems.filter(i => canSee(i, user));

  return (
    <>
      {open && <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.3)', zIndex: 39 }} onClick={onClose} />}
      <aside className={`sidebar${open ? ' open' : ''}`} style={{
        position: 'fixed', left: 0, top: 0, bottom: 0,
        width: 'var(--sidebar-width)', background: '#fff',
        borderRight: '1px solid var(--border)', display: 'flex', flexDirection: 'column',
        zIndex: 40, transition: 'transform 0.25s ease',
        boxShadow: '2px 0 8px rgba(0,0,0,0.04)'
      }}>
        {/* Brand */}
        <div style={{ padding: '18px 20px', borderBottom: '1px solid var(--border)', flexShrink: 0 }}>
          <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
            <Logo />
          </Link>
        </div>

        {/* User info */}
        <div style={{ padding: '14px 16px', borderBottom: '1px solid var(--border)', flexShrink: 0 }}>
          <button onClick={() => { navigate('/admin/profile'); onClose && onClose(); }}
            style={{ display: 'flex', alignItems: 'center', gap: 10, width: '100%', background: 'none', border: 'none', cursor: 'pointer', borderRadius: 8, padding: '4px 6px', margin: '-4px -6px', transition: 'background 0.15s' }}
            onMouseEnter={e => e.currentTarget.style.background = 'var(--surface-2)'}
            onMouseLeave={e => e.currentTarget.style.background = 'none'}
          >
            <div style={{
              width: 36, height: 36, borderRadius: '50%', background: 'var(--primary-lighter)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '0.95rem', fontWeight: 700, color: 'var(--primary)', flexShrink: 0
            }}>
              {user?.name?.charAt(0).toUpperCase()}
            </div>
            <div style={{ overflow: 'hidden', textAlign: 'left', flex: 1 }}>
              <div style={{ fontWeight: 600, fontSize: '0.875rem', color: 'var(--text-primary)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{user?.name}</div>
              <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', textTransform: 'capitalize' }}>{user?.role} · View Profile</div>
            </div>
          </button>
        </div>

        {/* Nav */}
        <nav style={{ flex: 1, overflowY: 'auto', padding: '10px 10px' }}>
          <div style={{ fontSize: '0.68rem', fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.8px', padding: '8px 10px 4px' }}>Main</div>
          {visibleNav.map(item => <NavItem key={item.to} item={item} onClose={onClose} />)}

          {visibleAdmin.length > 0 && (
            <>
              <div style={{ fontSize: '0.68rem', fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.8px', padding: '12px 10px 4px', marginTop: 4 }}>Admin</div>
              {visibleAdmin.map(item => <NavItem key={item.to} item={item} onClose={onClose} />)}
            </>
          )}
        </nav>

        {/* Footer */}
        <div style={{ padding: '12px 16px', borderTop: '1px solid var(--border)', flexShrink: 0 }}>
          <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', textAlign: 'center' }}>
            {COMPANY.shortName} CRM {COMPANY.crmVersion} &copy; {new Date().getFullYear()}
          </div>
        </div>
      </aside>
    </>
  );
}
